<template>
  <div class="base-input date-input">
    <label class="label-primary z-10" :for="id">{{ label }}</label>
    <VueDatePicker
      :uid="id"
      :model-value="value"
      :format="displayFormat"
      :enable-time-picker="false"
      auto-apply
      :clearable="true"
      placeholder="Any date"
      :teleport="true"
      @update:model-value="emit('update:value', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

defineProps<{
  id: string;
  label: string;
  value: Date | null;
}>();

const emit = defineEmits<{
  (e: 'update:value', value: Date | null): void;
}>();

// South African convention: "Tue 28 Jul 2026".
const displayFormat = (date: Date): string =>
  date.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).replace(/,/g, '');
</script>

<style>
/* Match the datepicker's input to the .input-primary look. */
.date-input .dp__input {
  @apply w-full py-2 px-3 pl-9 border border-gray-300 rounded-lg text-sm text-neutral-125 focus:border-red-500;
  font-family: inherit;
}
.date-input .dp__input:hover {
  @apply border-gray-300;
}
/* The calendar menu teleports to <body>, so brand the theme globally —
   #C9252F = tailwind primary.main. */
.dp__theme_light {
  --dp-primary-color: #C9252F;
}
</style>
